<template>
  <div class="app-wrapper" :class="classObj">
    <div class="main-logincontainer">
      <MainOi v-if="hosturl=='rsgl'"></MainOi>
      <Main v-else></Main>
    </div>
  </div>
</template>

<script>
import Main from "./components/Main.vue";
import MainOi from "./components/MainOi.vue";
// import Navbar from "./components/Navbar.vue";
// import Foot from "./components/Foot.vue";


export default {
  name: "login",  
  data() {
  return {
      hosturl:process.env.BASE_DOMAIN,
    };
  },
  components: {
    Main,MainOi
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        mobile: this.device === "mobile",
      };
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  // height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue